module.exports = __webpack_public_path__ + "static/media/poste_18.4e90451a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_18.jpg
// module id = 246
// module chunks = 0